import produce from 'immer';
import { handleActions } from 'redux-actions';

const initialState = {
  robotId: '',
  fromDate: '',
  fromTime: '',
  toDate: '',
  toTime: '',
  targetMessage: null,
};

export default handleActions(
  {
    'QUERY/SET': (state, action) =>
      produce(state, (draft) => {
        const { key, value } = action.payload;
        draft[key] = value;
      }),
    'QUERY/RESET': (state, action) => initialState,
  },
  initialState
);
